import React from 'react';

export default function CloseButton({ onClick }) {
  return (
    <div className="close-button" onClick={onClick}>
      <i className="icon-Add" />
    </div>
  );
}
